export default "__VITE_ASSET__3W0rZurU__"